/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

export enum MODAL_NAMES {
  all = 'correctedAllAddresses',
  billing = 'correctedBillingAddress',
  shipping = 'correctedShippingAddress',
}
